export const fr = {
  referralPage: {
    meta: {
      title: 'Programme de parrainage — Gagnez 1 000 $ pour chaque entreprise que vous référez',
    },
    header: {
      eyebrow: 'Programme de parrainage',
      subtitle:
        "Vous connaissez une équipe RH ou un VP Expérience Employé qui adorerait Purposely? Faites les présentations. Quand ils signent, vous recevez une récompense de 1 000 $ et ils obtiennent 10% de réduction sur leur première année.",
      cta: 'Faire une référence',
      ctaSecondary: 'Voir comment ça marche',
      mini: 'Aucune limite de références · Payé après la signature d\'un contrat d\'un an',
    },
    rewards: {
      you: {
        tag: 'Vous obtenez',
        amount: '1 000 $',
        unit: 'USD',
        headline: 'Récompense en argent, sans conditions',
        desc: 'Versé pour chaque référence réussie qui signe un contrat d\'un an avec Purposely.',
      },
      them: {
        tag: 'Ils obtiennent',
        amount: '10%',
        unit: 'de réduction an 1',
        headline: 'Un accueil chaleureux sur la plateforme',
        desc: 'Leur équipe obtient une réduction sur leur première année de Purposely — plus un accompagnement personnalisé de notre équipe.',
      },
    },
    collage: {
      eyebrow: 'Notre communauté',
      title: 'De vraies équipes. Un vrai impact. De vraies références.',
    },
    howItWorks: {
      eyebrow: 'Comment ça marche',
      titleHighlight: 'récompense de 1 000 $',
      subtitle: 'De l\'email d\'introduction au paiement — la plupart des références se concluent en moins de 30 jours.',
      options: {
        sendEmail: {
          title: 'Envoyez un e-mail',
          subtitle:
            "Utilisez le formulaire sur cette page (ou votre propre boîte mail) pour envoyer une introduction chaleureuse à quelqu'un qui adorera Purposely. Mettez eric@purposely.co en CC et nous nous occuperons du reste.",
        },
        friendGetsMessage: {
          title: 'Votre ami reçoit le message',
          subtitle:
            "Nous prendrons contact, partagerons une présentation personnalisée et organiserons la démo. Vous n'avez rien à faire — nous vous tenons informé à chaque étape.",
        },
        getRewarded: {
          title: 'Soyez récompensé',
          subtitle:
            "Quand l'équipe référée signe un contrat d'un an, nous vous verserons votre récompense de 1 000 $ dans les 14 jours ouvrables.",
        },
      },
    },
    form: {
      eyebrow: 'Faire une référence',
      title: 'Envoyez une introduction en deux minutes.',
      subtitle:
        "Dites-nous qui contacter. Nous prendrons le relais et vous tiendrons informé. Vos informations ne sont utilisées que pour suivre et créditer votre référence.",
      checklist: [
        "Nous vous mettrons en CC quand nous contacterons",
        'Références illimitées, aucune limite',
        'Payé dans les 14 jours suivant la signature du contrat',
      ],
      helperHeading: 'Vous avez déjà envoyé l\'email?',
      helperBody:
        "Assurez-vous simplement que eric@purposely.co est en CC et nous enregistrerons la référence automatiquement.",
      frameLabel: 'Formulaire de référence',
    },
    template: {
      eyebrow: 'Modèle d\'email',
      title: 'Copiez et collez notre modèle',
      titleHighlight: 'pour faciliter les choses.',
      subtitle:
        "Vous ne savez pas quoi dire? Utilisez ceci comme point de départ. Adaptez-le à votre style, ajoutez une note personnelle, et envoyez.",
      greeting: "Bonjour [Prénom de l'ami],",
      paragraph1:
        "J'espère que vous allez bien! Je voulais vous contacter au cas où votre entreprise explore des moyens de rendre l'engagement des employés plus impactant à travers le bénévolat. Pourriez-vous transmettre ce message à votre VP Ressources Humaines ou VP Expérience Employé pour découvrir Purposely et l'envisager pour votre organisation?",
      paragraph2:
        "Voici un bref résumé que vous pouvez transmettre à toute personne potentiellement intéressée:",
      paragraph3:
        "Purposely aide les entreprises à gérer des programmes de bénévolat structurés et à fort impact sans les complications habituelles de coordination. Conçu pour les équipes afin de favoriser un vrai engagement via le bénévolat en groupe, tout en suivant la participation et l'impact. Des entreprises comme Clio, Boston Dynamics et GreenShield l'utilisent déjà.",
      links: {
        title: 'Quelques liens utiles:',
        overview: 'Aperçu de Purposely',
        caseStudy: 'Étude de cas Clio',
      },
      ccReminder: "N'oubliez pas de mettre eric@purposely.co en CC",
      copyButton: 'Copier le modèle',
      alertSuccess: 'Modèle copié dans le presse-papiers!',
      alertError: 'Échec de la copie du texte. Veuillez réessayer.',
    },
    termsAndConditions: {
      title: 'Termes et conditions',
      subtitle:
        'La version simple: envoyez de vraies introductions, le contact doit signer un contrat d\'un an, et nous vous payons. La version complète est ci-dessous.',
      items: [
        {
          title: 'Les récompenses sont émises sur un contrat signé',
          body: "La récompense de 1 000 $ n'est versée que lorsqu'une organisation référée signe un contrat d'un an ou plus avec Purposely.",
        },
        {
          title: 'Références admissibles',
          body: "Les références doivent être initiées via une introduction par email (avec eric@purposely.co en CC) ou via le formulaire sur cette page. Purposely peut modifier ou mettre fin au programme de parrainage à tout moment sans préavis.",
        },
        {
          title: 'Litiges et admissibilité',
          body: "En cas de litige, Purposely déterminera les décisions finales d'admissibilité et de récompense. Les employés de Purposely et les clients actuels ne sont pas éligibles.",
        },
        {
          title: 'Méthode et délai de paiement',
          body: "Les récompenses sont payées par virement, ACH ou carte cadeau (votre choix) dans les 14 jours ouvrables suivant la signature du contrat référé. Les taxes locales sont de votre responsabilité.",
        },
      ],
    },
  },
}
